<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="8">
        <b-form onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              v-model="form.searchKey"
              @keyup.enter="clickQuery"
              type="search"
              :placeholder="
                $l('INDEX.table_label_fabric_search') ||
                  '面料编号/面料名称(中/英文)/工厂编号/面料成分(中/英文)搜索...'
              "
              size="sm"
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="visible = !visible"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="clickQuery">
                    <i class="fa fa-search"></i>
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="visible"
      width="1000px"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-form ref="form" :model="form" label-width="120px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.choose_fabric_agent') || '业务人员'"
            >
              <dict-select
                clearable
                v-model="form.fabricAgentCode"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                filterable
                size="small"
                url="/master/common/dict/baseUserSelect"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$l('INDEX.choose_fabric_supName') || '厂商'">
              <dict-select
                size="small"
                clearable
                filterable
                v-model="form.supCode"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                :body="scmParams"
                url="/master/common/dict/scmCooperated"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="
                $l('INDEX.choose_fabric_factoryFabricNumber') || '工厂面料编号'
              "
              prop="factoryNumber"
            >
              <el-input
                v-model="form.factoryNumber"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                maxlength="50"
                clearable
                size="small"
                style="width: 100%"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.choose_fabric_fabricName') || '面料'"
              prop="fabricDescriptionArray"
              ><el-select
                v-model="form.fabricDescriptionArray"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                size="small"
                filterable
                clearable
                multiple
                style="width: 100%"
              >
                <el-option
                  v-for="item in fabricDescriptionOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.choose_fabric_fabricNo') || '面料编号'"
              prop="fabricNo"
            >
              <el-input
                v-model="form.fabricNo"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
                maxlength="50"
                clearable
                size="small"
                style="width: 100%"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.choose_fabric_flowerType') || '花型'"
              prop="patternArray"
            >
              <el-select
                v-model="form.patternArray"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                size="small"
                filterable
                clearable
                multiple
                style="width: 100%"
              >
                <el-option
                  v-for="item in patternOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12"
            ><el-form-item
              :label="$l('INDEX.choose_fabric_technology') || '工艺'"
              prop="techniqueArray"
            >
              <el-select
                v-model="form.techniqueArray"
                multiple
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                size="small"
                filterable
                clearable
                style="width: 100%"
              >
                <el-option
                  v-for="item in techniqueOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12"> </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.choose_fabric_materialNotes') || '材料备注'"
              prop="constructionArray"
            >
              <el-select
                v-model="form.constructionArray"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                size="small"
                filterable
                clearable
                multiple
                style="width: 100%"
              >
                <el-option
                  v-for="item in constructionOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.choose_fabric_function') || '功能'"
              prop="functionArray"
            >
              <el-select
                v-model="form.functionArray"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                size="small"
                filterable
                clearable
                multiple
                style="width: 100%"
              >
                <el-option
                  v-for="item in functionOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item
                :label="$l('INDEX.choose_fabric_wid') || '有效门幅'"
              >
                <el-col :span="8">
                  <el-input-number
                    controls-position="right"
                    style="width: 100%"
                    size="small"
                    :min="0.01"
                    :step="0.01"
                    :placeholder="
                      $l('INDEX.tips_input_placeholder') || '请输入...'
                    "
                    v-model="form.widStart"
                  ></el-input-number>
                </el-col>
                <el-col class="line" :span="1">-</el-col>
                <el-col :span="8">
                  <el-input-number
                    controls-position="right"
                    size="small"
                    style="width: 100%"
                    :min="0.01"
                    :step="0.01"
                    :placeholder="
                      $l('INDEX.tips_input_placeholder') || '请输入...'
                    "
                    v-model="form.widEnd"
                  ></el-input-number>
                </el-col>
                <el-col :span="7">
                  <el-form-item prop="widUnit">
                    <dict-select
                      v-model="form.widUnit"
                      url="/master/common/dict/biz"
                      :body="{ dictType: 'widUnit' }"
                      :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                      size="small"
                      style="width: 100%"
                      filterable
                      clearable
                    ></dict-select>
                  </el-form-item>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item
                :label="$l('INDEX.choose_fabric_weight') || '面料克重'"
              >
                <el-col :span="8">
                  <el-input-number
                    controls-position="right"
                    style="width: 100%"
                    size="small"
                    :min="0.01"
                    :step="0.01"
                    :placeholder="
                      $l('INDEX.tips_input_placeholder') || '请输入...'
                    "
                    v-model="form.fabricWeightStart"
                  ></el-input-number>
                </el-col>
                <el-col class="line" :span="1">-</el-col>
                <el-col :span="8">
                  <el-input-number
                    controls-position="right"
                    size="small"
                    style="width: 100%"
                    :min="0.01"
                    :step="0.01"
                    :placeholder="
                      $l('INDEX.tips_input_placeholder') || '请输入...'
                    "
                    v-model="form.fabricWeightEnd"
                  ></el-input-number>
                </el-col>
                <el-col :span="7">
                  <el-form-item>
                    <dict-select
                      v-model="form.fabricWeightUnit"
                      url="/master/common/dict/biz"
                      :body="{ dictType: 'fabricWeightUnit' }"
                      :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                      size="small"
                      style="width: 100%"
                      filterable
                      clearable
                    ></dict-select>
                  </el-form-item>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消查询</el-button>
        <el-button size="small" type="warning" @click="onReset"
          >重置条件</el-button
        >
        <el-button size="small" type="primary" @click="clickQuery"
          >数据检索</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      visible: false,
      dialogVisible: false,
      turnoverVisible: false,
      form: {
        searchKey: '',
        fabricStatusArray: ['Y'],
        functionArray: [], //功能
        constructionArray: [], //材料备注
        fabricDescriptionArray: [], //面料名称
        patternArray: [], //花型
        techniqueArray: [], //工艺
        supCode: ''
      },
      scmParams: {},
      functionOptions: [], //功能
      constructionOptions: [], //材料备注
      fabricDescriptionOptions: [], //面料名称
      patternOptions: [], //花型
      techniqueOptions: [] //工艺
    }
  },
  mounted() {
    this.onReset()
    this.query()
  },
  methods: {
    clickQuery() {
      this.$emit('reset')
      this.query()
    },
    query() {
      this.$emit('submit', this.form)
      this.visible = false
    },
    onReset() {
      this.form = {
        searchKey: '',
        fabricStatusArray: ['Y'],
        functionArray: [], //功能
        constructionArray: [], //材料备注
        fabricDescriptionArray: [], //面料名称
        patternArray: [], //花型
        techniqueArray: [], //工艺
        supCode: ''
      }
      this.$emit('reset')
      this.loadSelectData()
    },
    closeDialog() {
      this.visible = false
    },
    loadSelectData() {
      //功能
      this.$api
        .masterFabricAttributesSelectApi({
          fabricAttrTypeEn: 'Function'
        })
        .then((res) => {
          this.functionOptions = res.body.data
        })
        .catch(() => {})
      //材料备注
      this.$api
        .masterFabricAttributesSelectApi({
          fabricAttrTypeEn: 'Construction'
        })
        .then((res) => {
          this.constructionOptions = res.body.data
        })
        .catch(() => {})
      //面料名称
      this.$api
        .masterFabricAttributesSelectApi({
          fabricAttrTypeEn: 'Fabric Description'
        })
        .then((res) => {
          this.fabricDescriptionOptions = res.body.data
        })
        .catch(() => {})
      //花型
      this.$api
        .masterFabricAttributesSelectApi({
          fabricAttrTypeEn: 'Pattern'
        })
        .then((res) => {
          this.patternOptions = res.body.data
        })
        .catch(() => {})
      //工艺
      this.$api
        .masterFabricAttributesSelectApi({
          fabricAttrTypeEn: 'Technique'
        })
        .then((res) => {
          this.techniqueOptions = res.body.data
        })
        .catch(() => {})
    }
  }
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
